
import smallCard from "../cards/smallCard.vue"

export default 
{
    name: "relatedDefault",    
    props: { 
        content: Object,
    },
    data()
    {
        return {
            relatedItems: {}
        }
    },
    components: { 
        smallCard 
    },
    async fetch()
    {
        let $items = {'empty' : ''};

                await this.$axios.$post('getrelated', {
                    "tags" : this.content.tags.split(', ') })
                    .then(resp => {
                        $items = resp.pages;
                    })
                    .catch(error => {
                    });
            
        this.relatedItems = $items;
    }
}
